import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { getTimezones } from '../../../../actions/user.js';
import Picture from './sections/picture';
import objectAssign from 'object-assign';
import { typingUserProfile } from '../../../../actions/user.js';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

const UserProfileCenterPanel = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const userPictureDesktopRef = useRef(ref);
  const userPictureMobileRef = useRef(ref);
  const [rotate, setRotate] = useState(0);
  const [profileImageDroppedScale, setProfileImageDroppedScale] = useState(1);
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  const timezones = useSelector((state) => state.usersReducer.timezones);
  const isProfileImageEditable = useSelector((state) => state.usersReducer.isProfileImageEditable);

  useEffect(() => {
    dispatch(getTimezones());
  }, []);

  const userProfileUpdated = (property, value) => {
    let userProfileUpdatedData = objectAssign({}, userProfile, {
      [property]: value,
    });
    dispatch(typingUserProfile(userProfileUpdatedData));
  };

  const userProfileMemberUpdate = (name) => {
    return (value) => {
      userProfileUpdated(name, value);
    };
  };

  const handleFirstNameChange = (value) => {
    userProfileUpdated('firstName', value);
  };

  const timezoneChanged = (event, element) => {
    userProfileUpdated('timezone', element.value);
  };

  useImperativeHandle(ref, () => ({
    getPictureBase64: () => {
      //at one time either userPicture will be there or userPicture Mobile will be there.
      const userPictureDesktop = userPictureDesktopRef.current || userPictureMobileRef.current;
      return userPictureDesktop.getBase64();
    },
  }));

  const setRotation = (rotatePic) => {
    setRotate(rotatePic);
  };
  const setProfileImageDroppedScaleMethod = (profileImageDroppedScale) => {
    setProfileImageDroppedScale(profileImageDroppedScale);
  };

  return (
    <span>
      <div className="ui fluid form ">
        <div className="ui sixteen column grid mrtnull mrbl">
          <div className="pdtnull sixteen wide column details-section checkLeft">
            <div className=" mrtm">
              <div className="ui sixteen column grid hide-on-mobile">
                <div className="ten wide column">
                  <ValidMe validmefor="optional" group="profileSaveChanges">
                    <Txt
                      fieldClasses=""
                      maxLength={16}
                      noTitle
                      onChange={userProfileMemberUpdate('honorific')}
                      value={userProfile.honorific || ''}
                      placeholder={APP.LANGUAGE.UserProfile.Honorific}
                      type="text"
                    />
                  </ValidMe>
                  <ValidMe validmefor="nonLetterNonNumber" group="profileSaveChanges">
                    <Txt
                      fieldClasses="mrtl "
                      maxLength={32}
                      noTitle
                      onChange={userProfileMemberUpdate('firstName')}
                      value={userProfile.firstName || ''}
                      placeholder={APP.LANGUAGE.UserProfile.FirstName}
                      type="text"
                    />
                  </ValidMe>
                  <ValidMe validmefor="nonLetterNonNumber@optional" group="profileSaveChanges">
                    <Txt
                      fieldClasses="mrtl "
                      maxLength={32}
                      noTitle
                      onChange={userProfileMemberUpdate('lastName')}
                      placeholder={APP.LANGUAGE.UserProfile.LastName}
                      value={userProfile.lastName || ''}
                      type="text"
                    />
                  </ValidMe>
                  <ValidMe validmefor="optional" group="profileSaveChanges">
                    <Txt
                      noTitle
                      maxLength={16}
                      onChange={userProfileMemberUpdate('suffix')}
                      placeholder={APP.LANGUAGE.UserProfile.Suffix}
                      value={userProfile.suffix || ''}
                      type="text"
                    />
                  </ValidMe>
                </div>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="six wide column alignImageWithTop mrbnull pdbnull"
                >
                  <Picture
                    ref={userPictureDesktopRef}
                    rotate={rotate}
                    profileImageDroppedScaleParent={profileImageDroppedScale}
                    setProfileImageDroppedScaleMethod={setProfileImageDroppedScaleMethod}
                    setRotation={setRotation}
                  />
                </Container>
              </div>

              <div className="show-on-mobile">
                <ValidMe validmefor="optional" group="profileSaveChanges">
                  <Txt
                    fieldClasses=""
                    maxLength={16}
                    noTitle
                    onChange={userProfileMemberUpdate('honorific')}
                    value={userProfile.honorific || ''}
                    placeholder={APP.LANGUAGE.UserProfile.Honorific}
                    type="text"
                  />
                </ValidMe>
                <ValidMe validmefor="nonLetterNonNumber" group="profileSaveChanges">
                  <Txt
                    fieldClasses="mrtl "
                    maxLength={32}
                    noTitle
                    onChange={userProfileMemberUpdate('firstName')}
                    value={userProfile.firstName || ''}
                    placeholder={APP.LANGUAGE.UserProfile.FirstName}
                    type="text"
                  />
                </ValidMe>
                <ValidMe validmefor="nonLetterNonNumber@optional" group="profileSaveChanges">
                  <Txt
                    fieldClasses="mrtl "
                    maxLength={32}
                    noTitle
                    onChange={userProfileMemberUpdate('lastName')}
                    placeholder={APP.LANGUAGE.UserProfile.LastName}
                    value={userProfile.lastName || ''}
                    type="text"
                  />
                </ValidMe>
                <ValidMe validmefor="optional" group="profileSaveChanges">
                  <Txt
                    noTitle
                    maxLength={16}
                    onChange={userProfileMemberUpdate('suffix')}
                    placeholder={APP.LANGUAGE.UserProfile.Suffix}
                    value={userProfile.suffix || ''}
                    type="text"
                  />
                </ValidMe>

                <div />
              </div>
              <div className="  mrtxxs">
                <ValidMe validmefor="nonLetterNonNumber@optional" group="profileSaveChanges">
                  <Txt
                    maxLength={64}
                    fieldClasses="mrtl "
                    noTitle
                    onChange={userProfileMemberUpdate('waitingAreaAlias')}
                    placeholder={APP.LANGUAGE.UserProfile.WaitingAreaAlias}
                    value={userProfile.waitingAreaAlias || ''}
                  />
                </ValidMe>
              </div>
              <div className="mrtxs">
                <label className="placeholder-label  no-bold title-sms color-info-mid-grey-desktop">
                  {APP.LANGUAGE.UserProfile.EmailAddress}
                </label>
                <div className="mrls word-break">{' ' + userProfile.email}</div>
                <div className="placeholder-label title-sms color-info-mid-grey-desktop mrls mrtxxs">
                  {APP.LANGUAGE.UserProfile.EmailAddressCaption}
                </div>
              </div>
              <div className="field mrtl mrbnull">
                <Txt
                  text="text"
                  value="value"
                  semanticui
                  normal
                  dropdown
                  selectedItemPlaceholder={APP.LANGUAGE.UserProfile.SelectTimezone}
                  selectedValue={userProfile.timezone}
                  placeholder={APP.LANGUAGE.UserProfile.LoadingTimezone}
                  options={timezones}
                  onChange={timezoneChanged}
                />
              </div>
              <Container fluid as={Media} at="mobile" className="mrtl">
                <Picture
                  ref={userPictureMobileRef}
                  rotate={rotate}
                  profileImageDroppedScale={profileImageDroppedScale}
                  setProfileImageDroppedScale={setProfileImageDroppedScale}
                  setRotation={setRotation}
                />
              </Container>
            </div>
          </div>
        </div>
      </div>
    </span>
  );
});

UserProfileCenterPanel.displayName = 'UserProfileCenterPanel';

export default UserProfileCenterPanel;
